<template>
  <div class="dashboard-vertical-chart-container">
    <h3>{{$t( subtitle)}}</h3>
    <div :id="alias" class="vertical-chart" />
  </div>
</template>

<script>
import * as d3 from "d3";
import {ChartBarSimpleVertical} from "@/utils/ChartBarSimpleVertical";

export default {
  name: "DashboardChartVertical",
  props: {
    chartData: {
      type: Array,
      default: () => [],
    },
    alias: {
      type: String,
      default: "",
    },
    subtitle: {
      type: String,
      default: "",
    },
  },
  data() {
    return {};
  },
  watch: {
    alias: function (newVal, oldVal) {
      var svg = this.$d3.select("#" + oldVal);
      this.updateChart();
    },
    chartData: function () {
      this.updateChart();
    },
    '$i18n.locale':function () {
      this.updateChart();
    },
  },
  mounted() {
    d3.select(window).on("resize", () => {
      setTimeout(()=>this.updateChart(),2000)
    });
    this.updateChart();
  },
  methods: {
    updateChart() {
      var svg = this.$d3.select("#" + this.alias);
      svg.selectAll(".chart").remove();
      this.chart = new ChartBarSimpleVertical(
        this.alias,
        { data: this.chartData },

      );
       this.chart.render()

    },
  },
};
</script>
<style lang="scss" scoped>
.dashboard-pie-container {
  width: 100%;
}

.vertical-chart {
  height: 220px;
  min-width: 315px;
}

</style>
